import React from 'react'

export default function CourseInstructor(props) {
  return (
    <>
    <span>{props.instructor}</span>
    </>
  )
}
